import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/my_business/info_shadow.png';

const StyledInfoItem = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	padding: 17px 20px 20px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledInfoItemTitle = styled(Text)`
	position: relative;
	z-index: 2;
	font-size: 14px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledInfoItemValue = styled.div`
	position: relative;
	z-index: 2;
	margin-top: 27px;
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 500;
		font-size: 20px;
		color: #ffffff;

		span {
			font-weight: 400;
			opacity: 0.5;
		}
	}
`;

const StyledInfoItemShadow = styled.div`
	position: absolute;
	right: -250px;
	bottom: -250px;
	width: 500px;
	height: 500px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	z-index: 1;
	pointer-events: none;
`;

const StyledItemBottomContainer = styled.div`
	position: relative;
	z-index: 2;
	margin-top: auto;
`;

export {
	StyledInfoItem,
	StyledInfoItemShadow,
	StyledInfoItemTitle,
	StyledInfoItemValue,
	StyledItemBottomContainer,
};
